import { useEffect, useState } from "react";
import api from "../api";

// come si legge la modalità nella pagina pubblica (le modalità non elencate non vengono scritte)
const MODE_LABEL = {
  presenza: "in studio", studio: "in studio", zoom: "in videochiamata",
  phone: "telefonico", trasferta: "presso la vostra sede",
};

export default function PublicConfirm() {
  const p = new URLSearchParams(window.location.search);
  const id = p.get("appt") || "";
  const [card, setCard] = useState(null);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const [move, setMove] = useState(false);
  const [busy, setBusy] = useState(false);
  const [studio, setStudio] = useState(null);

  useEffect(() => {
    if (!id) { setErr("Link non valido."); return; }
    api.get(`/appointments/${id}/card`).then((r) => {
      setCard(r.data);
      if (r.data.client_confirmed) setDone(true);
    }).catch(() => setErr("Appuntamento non trovato."));
    api.get("/booking-config").then((r) => setStudio(r.data.studio || null)).catch(() => {});
  }, [id]);

  const confirm = async () => {
    setBusy(true);
    try { await api.post(`/appointments/${id}/client-confirm`); setDone(true); }
    catch (e) { alert(e.response?.data?.detail || "Errore, riprova."); }
    setBusy(false);
  };

  const acceptProposal = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/appointments/${id}/accept-proposal`);
      setCard((c) => ({ ...c, status: "confermato", date: r.data.date, time: r.data.time, proposed_date: null }));
      setDone(true);
    } catch (e) { alert(e.response?.data?.detail || "Errore, riprova."); }
    setBusy(false);
  };

  if (err) return <div className="public-wrap"><div className="public-card"><p>{err}</p></div></div>;
  if (!card) return <div className="public-wrap"><p className="muted">Caricamento…</p></div>;

  const dataIt = String(card.date || "").split("-").reverse().join("/");
  const propIt = String(card.proposed_date || "").split("-").reverse().join("/");
  const isProposal = card.status === "controproposta" && card.proposed_date && !done;
  if (isProposal) {
    return (
      <div className="public-wrap">
        <div className="public-card" style={{ textAlign: "center" }} data-testid="public-proposal-card">
          <h1 className="page-title">Nuova proposta di data</h1>
          <p className="page-sub">Studio Dott.ssa Silvia Casali — Commercialista</p>
          <p style={{ fontSize: 17 }}>
            {card.name ? <>Gentile <strong>{card.name}</strong>,<br /></> : null}
            l'orario del <s>{dataIt} alle {card.time}</s> non è disponibile.<br />
            Le proponiamo in alternativa: <strong>{propIt}</strong> alle <strong>{card.proposed_time}</strong>.
          </p>
          <button className="btn primary" style={{ fontSize: 17, padding: "12px 28px", marginTop: 8 }} onClick={acceptProposal} disabled={busy} data-testid="accept-proposal-btn">
            {busy ? "Un attimo…" : "✔ Accetto la nuova data"}
          </button>
          <p style={{ marginTop: 18 }}>
            <button className="btn sm" onClick={() => setMove(true)} data-testid="proposal-move-btn">Preferisco un altro orario</button>
          </p>
          {move && (
            <p className="muted" style={{ fontSize: 14 }} data-testid="proposal-move-info">
              Nessun problema! Ci contatti per trovare un nuovo orario:{" "}
              {studio?.phone ? <><a href={`tel:${studio.phone}`}>{studio.phone}</a>{" · "}</> : null}
              {studio?.email ? <a href={`mailto:${studio.email}`}>{studio.email}</a> : "rispondendo al messaggio ricevuto."}
            </p>
          )}
        </div>
      </div>
    );
  }
  return (
    <div className="public-wrap">
      <div className="public-card" style={{ textAlign: "center" }} data-testid="public-confirm-card">
        <h1 className="page-title">Conferma appuntamento</h1>
        <p className="page-sub">Studio Dott.ssa Silvia Casali — Commercialista</p>
        <p style={{ fontSize: 17 }}>
          {card.name ? <>Gentile <strong>{card.name}</strong>,<br /></> : null}
          il suo appuntamento è previsto per <strong>{dataIt}</strong> alle <strong>{card.time}</strong>
          {card.mode && card.mode !== "blocco" && MODE_LABEL[card.mode] ? <> ({MODE_LABEL[card.mode]})</> : null}.
        </p>
        {done ? (
          <p style={{ color: "#22c55e", fontSize: 18, fontWeight: 700 }} data-testid="confirm-done">
            ✔ Appuntamento confermato, grazie!<br />
            <span style={{ fontWeight: 400, fontSize: 14 }}>Ci vediamo il {dataIt} alle {card.time}.</span>
          </p>
        ) : (
          <>
            <button className="btn primary" style={{ fontSize: 17, padding: "12px 28px", marginTop: 8 }} onClick={confirm} disabled={busy} data-testid="confirm-btn">
              {busy ? "Un attimo…" : "✔ Confermo l'appuntamento"}
            </button>
            <p style={{ marginTop: 18 }}>
              <button className="btn sm" onClick={() => setMove(true)} data-testid="move-btn">Devo spostarlo</button>
            </p>
            {move && (
              <p className="muted" style={{ fontSize: 14 }} data-testid="move-info">
                Nessun problema! Ci contatti per trovare un nuovo orario:{" "}
                {studio?.phone ? <><a href={`tel:${studio.phone}`}>{studio.phone}</a>{" · "}</> : null}
                {studio?.email ? <a href={`mailto:${studio.email}`}>{studio.email}</a> : "rispondendo al messaggio ricevuto."}
              </p>
            )}
          </>
        )}
      </div>
    </div>
  );
}
